// ----------------------------------------------------------------------

export const JWT_STORAGE_KEY = 'jwt_access_token';
